import { Droplets, Minus, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

interface WaterCounterProps {
  value: number;
  onChange: (val: number) => void;
}

const presets = [2, 4, 6, 8, 10];

export const WaterCounter = ({ value, onChange }: WaterCounterProps) => {
  const handleDecrement = () => onChange(Math.max(0, value - 1));
  const handleIncrement = () => onChange(value + 1);

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground flex items-center gap-1.5">
        <Droplets className="h-4 w-4 text-wellness-blue" />
        Agua (vasos)
      </h3>
      
      <div className="flex flex-col items-center gap-4 bg-background p-4 rounded-2xl border">
        <div className="flex items-center justify-between w-full max-w-[200px]">
          <button 
            onClick={handleDecrement}
            className="w-10 h-10 rounded-full bg-secondary text-foreground flex items-center justify-center hover:bg-secondary/80 transition-colors active:scale-95"
          >
            <Minus className="h-5 w-5" />
          </button>
          
          <div className="text-3xl font-heading font-bold text-foreground w-16 text-center">
            {value}
          </div>
          
          <button 
            onClick={handleIncrement}
            className="w-10 h-10 rounded-full bg-wellness-blue/10 text-wellness-blue flex items-center justify-center hover:bg-wellness-blue/20 transition-colors active:scale-95"
          >
            <Plus className="h-5 w-5" />
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-2 w-full pt-4 mt-2 border-t border-border/50">
          {presets.map((preset) => (
            <button
              key={preset}
              onClick={() => onChange(preset)}
              className={cn(
                "px-3 py-1.5 rounded-lg text-xs font-medium transition-all border",
                value === preset 
                  ? "bg-wellness-blue border-wellness-blue text-white shadow-sm" 
                  : "bg-transparent border-border hover:border-wellness-blue/40 text-muted-foreground"
              )}
            >
              {preset}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
